import React from 'react'
import { Redirect,  Switch } from 'react-router-dom'
import { ContentRoute } from '../../../_metronic/layout' 
import DefaultSettingList from './list/DefaultSettingList'

export default function DefaultSettingPage() {
    return (
        <Switch>
            <Redirect exact={true} from="/default-settings" to="/default-settings/list" />
            <ContentRoute from={ "/default-settings/list"} component={DefaultSettingList} />
        </Switch>)
}
